export default "__VITE_ASSET__f3a2d379__"